<template>
    <popper
        ref="popper"
        trigger="clickToToggle"
        root-class="cz3__tip"
        transition="cz2__fade"
        :options="{
            placement: 'auto',
            modifiers: { offset: { offset: '0, 10px' } }
        }"
    >
        <div class="popper cz3__popper">
            {{tip}}

            <button
                :aria-label="$t('V3_CLOSE')"
                class="cz3__popper-close"
                @click.prevent="close"
            >
                <!-- eslint-disable -->
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"><mask id="close-a" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g mask="url(#close-a)"><path fill="#000" d="m5.334 15.833-1.167-1.166L8.834 10 4.167 5.333l1.167-1.166L10 8.833l4.667-4.666 1.167 1.166L11.167 10l4.667 4.667-1.167 1.166L10 11.167l-4.666 4.666Z"/></g></svg>
                <!-- eslint-disable -->
            </button>
        </div>

        <button slot="reference" class="cz3__info-tip">
            <!-- eslint-disable -->
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><g clip-path="url(#info-a)"><path fill="#000" d="M8 1.333A6.67 6.67 0 0 0 1.335 8a6.67 6.67 0 0 0 6.667 6.667A6.67 6.67 0 0 0 14.667 8a6.67 6.67 0 0 0-6.666-6.667Zm.667 10H7.334v-4h1.333v4Zm0-5.333H7.334V4.667h1.333V6Z"/></g><defs><clipPath id="info-a"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs></svg>
            <!-- eslint-enable -->
        </button>
    </popper>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz3__info-tip {
            margin-left: 3px;

            width: 16px;
            height: 16px;

            border: none;
            border-radius: 8px;

            vertical-align: -2px;

            &:focus {
                outline: 2px solid #000;
                outline-offset: 2px;
            }
        }
    }
</style>

<script>
    import Popper from 'vue-popperjs';

    export default {
        components: {
            Popper,
        },

        props: {
            tip: String,
        },

        methods: {
            close() {
                this.$refs.popper.doClose();
            },
        },
    };
</script>
